import React, { useEffect, useCallback, useRef, useContext, useState } from 'react'
import { AgGridReact } from 'ag-grid-react';
import { fetchSubscriberTeams } from '../services';
import { MyContext } from '..';
import { Input } from '../GitHubComponents/Inputs';
import Button from '../GitHubComponents/Button'
import { Link } from 'react-router-dom';

export default function Teams(props) {
    const { backendUrl } = useContext(MyContext)
    const subscriberCode = props.subCode
    document.title = props.title
    const gridRef = useRef();
    const [teams, setTeams] = useState([])
    const columns = [
        { field: 'id', headerName: 'Id', width: 100, pinned: 'left' },
        { field: 'name', headerName: 'Name', width: 180, pinned: 'left' },
        { field: 'description', headerName: 'Description', flex: 2 },
        { field: 'members', headerName: 'Members', flex: 3},
    ];
    const fetchData = useCallback(async () => {
        try {
            const data = await fetchSubscriberTeams(backendUrl, subscriberCode);
            setTeams(data.data)
        } catch (error) {
            console.error('Error fetching Users data:', error);
        }
    }, [backendUrl, subscriberCode])
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            'quickFilterText',
            document.getElementById('filter-text-box').value
        );
    }, []);
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (
        <div className="teams-body px-4" >
            <div className='grid-head d-flex'>
                <div className="example-header">
                    <span>Quick Filter:</span>
                    <Input type={"text"} id={"filter-text-box"} onInput={onFilterTextBoxChanged} style={{ display: "inline-block" }} />
                </div>
                {/* {selectedRows.length > 0 && <Button text={"Update role"} onClick={openModal} style={{ color: "white ", backgroundColor: "#1f883d", marginTop: "19px" }} />} */}
                
                <Link to={"../new-team"}>
                    <Button text={"New team"} style={{ color: "white ", backgroundColor: "#1f883d", marginTop: "19px" }}/>
                </Link>
            </div>
            <div className="ag-theme-quartz" style={{ height: "80vh", width: '100%' }}>
                <AgGridReact ref={gridRef} rowData={teams} columnDefs={columns} suppressRowClickSelection={true} pagination={true} />
            </div>
        </div>
    )
}
